import omitEmptyValues from '../../../shared/utils/omit-empty-values/omit-empty-values';
import { TemplateField } from '../../templates/models/template-field';
import { mapDateSearchParams } from './map-date-search-params';

interface BuildSignRequestFiltersPayloadOptions {
  searchParams: URLSearchParams;
  templateFields?: TemplateField[];
  overrides?: Record<string, number | string | undefined>;
  selectedSignRequestIds?: string[];
}

export const buildSignRequestFiltersPayload = ({
  searchParams,
  templateFields = [],
  overrides = {},
  selectedSignRequestIds = [],
}: BuildSignRequestFiltersPayloadOptions) => {
  const payload = {
    page: searchParams.get('page') ? Number(searchParams.get('page')) : undefined,
    limit: searchParams.get('limit') ? Number(searchParams.get('limit')) : undefined,
    name: searchParams.get('name') || '',
    clientUser: searchParams.get('clientUser') || '',
    unit: searchParams.get('unit') || '',
    customerId: searchParams.get('customerId') || '',
    template: searchParams.get('template') || '',
    status: searchParams.get('status') || '',
    ...(searchParams.has('archived') && {
      archived: searchParams.get('archived') === '1' ? '1' : '0',
      canArchive: '1',
    }),
    ...templateFields.reduce<Record<string, string>>((params, templateField) => {
      const value = searchParams.get(templateField.name);

      if (!value) {
        return params;
      }

      return {
        ...params,
        [templateField.name]: value,
      };
    }, {}),
    ...mapDateSearchParams(searchParams.get('dateFromTo') || ''),
    ...(selectedSignRequestIds.length > 0 && {
      id: selectedSignRequestIds.join(','),
    }),
    ...overrides,
  };

  return omitEmptyValues(payload);
};
